import { render, staticRenderFns } from "./TransportView.vue?vue&type=template&id=6ff0b042&scoped=true"
import script from "./TransportView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TransportView.vue?vue&type=style&index=0&id=6ff0b042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0b042",
  null
  
)

export default component.exports